import { forwardRef, useState } from 'react'

import { useAppContext } from 'context/app-context'
import { FilterOption } from './filter-option'
import {
  Container,
  FilterToggle,
  List,
  SearchField,
  Summary,
  Divider,
} from './styled'
import { FilterKey, useFiltersContext } from 'context/filters-context'

export const Filters = forwardRef<HTMLLIElement, {}>(() => {
  const { data, strings } = useAppContext()
  const { filters, setFilters, options, search, setSearch, filteredData } =
    useFiltersContext()
  const monthLabels = strings.filters_months.split(',')
  const [openFilter, setOpenFilter] = useState<FilterKey | ''>('')

  return (
    <Container>
      <List>
        <li>
          <SearchField
            placeholder={strings.filters_search_placeholder}
            type="search"
            value={search}
            onChange={evt => setSearch(evt.target.value)}
          />
        </li>

        <FilterOption
          isOpen={openFilter === 'region'}
          filterKey="region"
          options={options.region}
          onOpenToggle={setOpenFilter}
          label={
            filters.subregion || filters.region || strings.filters_by_region
          }
          renderSubfilters={value =>
            Object.keys(options.region[value].subregions).filter(
              s => s !== value
            ).length > 0 && (
              <>
                {Object.entries(options.region[value].subregions).map(
                  ([subregionName, subregions]) => (
                    <li key={subregionName}>
                      <FilterToggle
                        disabled={
                          filters.region === value &&
                          filters.subregion === subregionName
                        }
                        onClick={() =>
                          setFilters(f => ({
                            ...f,
                            subregion: subregionName,
                            region: value,
                          }))
                        }
                      >
                        <span>{subregionName}</span> <span>{subregions}</span>
                      </FilterToggle>
                    </li>
                  )
                )}
              </>
            )
          }
        />

        <FilterOption
          isOpen={openFilter === 'military'}
          filterKey="military"
          options={options.military}
          onOpenToggle={setOpenFilter}
          label={filters.military || strings.filters_by_military}
        />

        <FilterOption
          isOpen={openFilter === 'year'}
          filterKey="year"
          options={options.year}
          label={
            filters.month
              ? `${filters.month}/${filters.year}`
              : filters.year || strings.filters_by_year
          }
          onOpenToggle={setOpenFilter}
          renderSubfilters={value =>
            /^\d{4}$/.test(value) ? (
              <>
                {[...Array(12)].map((_, i) => {
                  const month = (i + 1).toString().padStart(2, '0')

                  return (
                    <li key={i}>
                      <FilterToggle
                        disabled={
                          filters.year === value && filters.month === month
                        }
                        onClick={() =>
                          setFilters(f => ({
                            ...f,
                            month: month,
                            year: value,
                          }))
                        }
                      >
                        <span>
                          {value} | {monthLabels[i]}
                        </span>{' '}
                        <span>
                          {
                            data?.filter(item =>
                              item.date_of_death
                                .toString()
                                .includes(`${month}.${value}`)
                            ).length
                          }
                        </span>
                      </FilterToggle>
                    </li>
                  )
                })}
              </>
            ) : null
          }
        />
        <Divider />
        <Summary>
          {strings.filters_total_results_before}{' '}
          <span>
            {filteredData?.length}
            {strings.filters_total_results_after}
          </span>
        </Summary>
      </List>
    </Container>
  )
})
